// created by wang.ao 2019/08/01
import { Api } from '../types/Api';

// demo
const demoHelloWorld: Api = {
    url: '/demo/v1/hello-world',
    method: 'get',
};

// 测试get请求带参数
const demoUser: Api = {
    url: '/demo/v1/user',
    method: 'get',
};

// 测试post请求带参数
const demoAdd: Api = {
    url: '/demo/v1/add',
    method: 'post',
};

// 测试put请求带参数
const demoPut: Api = {
    url: '/demo/v1/put',
    method: 'put',
};

// 测试put请求带参数
const demoDelete: Api = {
    url: '/demo/v1/delete',
    method: 'delete',
};

// 测试业务异常
const demoTestError: Api = {
    url: '/demo/v1/test/error',
    method: 'get',
};

// 测试业务异常
const demoTestLogin: Api = {
    url: '/demo/v1/test/login',
    method: 'get',
};

export { demoHelloWorld, demoUser, demoAdd, demoPut, demoDelete, demoTestError, demoTestLogin };
